/* eslint eqeqeq: "off" */
import React, { useEffect, useState, useRef } from "react";
import {
  Breadcrumb,
  Col,
  FloatButton,
  Spin,
  Image,
  Input,
  Modal,
  Row,
} from "antd";
import { MetaTags } from "react-meta-tags";
import {
  CommentOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { FaLocationDot } from "react-icons/fa6";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";
import Activity1 from "../../assets/images/udaipur.jpg";
import Activity2 from "../../assets/images/kashmir-activity.png";
import Activity3 from "../../assets/images/adiyogi.png";
import "./index.css";
import ActivityDetails from "./activity-details";
// import { loadDestinationList } from "../../store/dashboard/actions";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { activitiesList } from "./data";
import { loadActivitiesList } from "../../store/activities-list/actions";
import api from "../../helpers";

const Activities = () => {
  const [chatModal, setChatModal] = useState(false);

  const media = useMedia();
  const dispatch = useDispatch();
  const history = useHistory();

  //store integrations

  useEffect(() => {
    // dispatch(loadDestinationList());
    dispatch(loadActivitiesList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const { destination_list = [] } = useSelector((state) => state.Dashboard);
  const { activities_list = [] } = useSelector((state) => state.Activities);
  const activitiesDetails =
    activities_list &&
    activities_list.queryResult &&
    activities_list.queryResult.length > 0
      ? activities_list.queryResult.map((data) => {
          return {
            destinationId: data.destinationId,
            lowestPrice: data.lowestPrice,
            activities: data.noOfActivities,
            packageName: data.destinationName,
            imageUrl:
              data.image && data.image.length > 0 ? data.image[0].imageUrl : "",
            // imageUrl: data.images && imageUrl !== "" ? imageUrl : "",
          };
        })
      : [];
  // const destinationOptions =
  //   destination_list &&
  //   destination_list.queryResult &&
  //   destination_list.queryResult.length > 0
  //     ? destination_list.queryResult.map((data) => {
  //         const imageUrl =
  //           data.images && data.images.length > 0
  //             ? data.images[0].imageUrl
  //             : "";
  //         return {
  //           destinationName: data.destinationName,
  //           imageUrl: data.images && imageUrl !== "" ? imageUrl : "",
  //           _id: data._id,
  //         };
  //       })
  //     : [];

  const slides = [
    {
      id: 1,
      content: (
        <Image
          preview={false}
          src={Activity2}
          height={275}
          style={{
            objectFit: "cover",
            backgroundPosition: "cover",
            display: "block",
          }}
          width={"100%"}
        />
      ),
    },
    {
      id: 2,
      content: (
        <Image
          preview={false}
          src={Activity1}
          height={275}
          style={{
            objectFit: "cover",
            backgroundPosition: "cover",
            display: "block",
          }}
          width={"100%"}
        />
      ),
    },
    {
      id: 3,
      content: (
        <Image
          preview={false}
          src={Activity3}
          height={275}
          style={{
            objectFit: "cover",
            backgroundPosition: "cover",
            display: "block",
          }}
          width={"100%"}
        />
      ),
    },
  ];

  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    centerPadding: "5px",
    slidesToShow: 1,
    fade: true,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 2800,
  };

  const [query, setQuery] = useState("");
  const [destinationLoading, setDestinationLoading] = useState(false);
  // const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [searchArrays, setSearchArrays] = useState([]);
  const [searchDestinationSelected, setSearchDestinationSelected] =
    useState(false);
  const [destinationSelected, setDestinationSelected] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  // const handleChange = (e) => {
  //   const userInput = e.target.value;
  //   // const filtered = destinationOptions.filter((s) =>
  //   //   s.destinationName.toLowerCase().includes(userInput.toLowerCase())
  //   // );
  //   // console.log(userInput, "userInput")
  //   const filtered = activitiesDetails
  //     .filter((row) =>
  //       row.packageName.toLowerCase().includes(e.target.value.toLowerCase())
  //     )
  //     .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

  //   setQuery(userInput);
  //   setFilteredSuggestions(userInput ? filtered : []);
  // };
  const handleChange = (e) => {
    const userInput = e.target.value.toLowerCase();

    // const filtered = destinationOptions
    //   .filter((row) => row.destinationName.toLowerCase().includes(userInput))
    //   .filter(
    //     (item, index, self) =>
    //       index ===
    //       self.findIndex((t) => t.destinationName === item.destinationName)
    //   );
    setSearchDestinationSelected(true);
    setDestinationLoading(true);
    setTimeout(() => {
      setDestinationLoading(false);
    }, 3000);
    if (userInput !== "") {
      api
        .get(
          `/package/top-search-drop-down-data?searchFilter=${userInput}&isDestinationFilter=${true}`
        )
        .then((res) => {
          // setFilteredSuggestions(res.data.data)
          setSearchArrays(
            res.data && res.data.data && res.data.data.data
              ? res.data.data.data
              : []
          );
          console.log(res.data, "response from search");
          return res.data;
        })
        .catch((error) => Promise.reject(error));
    } else {
      setSearchArrays([]);
      setSearchDestinationSelected(false);
    }
    // dispatch(loadDestinationSearchList(`?searchFilter=${userInput}`));

    setQuery(e.target.value);
    // setFilteredSuggestions([]);
    // setFilteredSuggestions(userInput ? filtered : []);
  };
  const destinationSearchRef = useRef(null);
  // Close dropdown when clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        destinationSearchRef.current &&
        !destinationSearchRef.current.contains(event.target)
      ) {
        setSearchDestinationSelected(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // const handleClick = (suggestion) => {
  //   setQuery(suggestion.destinationName);
  //   setValueSelected(suggestion.destinationName);
  //   setFilteredSuggestions([]);
  // };

  // console.log(filteredSuggestions, "filteredSuggestions");

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Explore Fun & Adventure destinations | Plan mi trip</title>
        </MetaTags>
      </div>
      <Col
        md={24}
        sm={24}
        lg={24}
        xl={24}
        xxl={24}
        className="mr-[-6px] mt-[-20px]"
      >
        <div
          style={{
            width: "101%",
            marginLeft: "-6px",
          }}
        >
          {/* Slider contents with auto search fields */}
          <Slider {...settings} centerMode className="h-[100%] w-[100%]">
            {slides.map((slide) => (
              <div
                key={slide.id}
                className={
                  media == "md" || media == "sm" || media == "xs"
                    ? "h-[280px]"
                    : "h-[280px]"
                }
              >
                <h2
                  style={{
                    width: "100%",
                  }}
                >
                  {slide.content}
                </h2>
                <div
                  style={{
                    position: "absolute",
                    top: "0px",
                    bottom: "4px",
                    //   marginLeft: "1px",
                    width: "100%",
                    color: "#ffffff",
                    fontSize: "18px",
                    fontFamily: "Poppins",
                    fontWeight: 700,
                    //   zIndex: 20,
                    padding: "20px",
                    background: "#0000003d",
                  }}
                >
                  <Col
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className="flex justify-center"
                  >
                    <Row
                      className={
                        media == "md" || media == "sm" || media == "xs"
                          ? "mt-[120px] flex justify-center"
                          : "w-[70%] mt-[120px] flex justify-center"
                      }
                    >
                      <div
                        className={
                          media == "xl" || media == "lg" || media == "xxl"
                            ? "mt-[-8px] w-[65%]"
                            : "mt-[-8px] w-[100%]"
                        }
                      >
                        <Input
                          size={
                            media == "sm" || media == "xs" ? "small" : "large"
                          }
                          placeholder="Search for location or activity!"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "65px",
                            // border: "0.5px solid lightgray",
                            padding:
                              media == "sm" || media == "xs"
                                ? "6px 10px"
                                : media == "md"
                                ? "6px 10px"
                                : "6px 12px",
                            borderRadius: "6px",
                            fontSize: "20px",
                            fontWeight: 700,
                          }}
                          prefix={
                            <FaLocationDot className="text-[20px] text-[#eb3e43] mr-2" />
                          }
                          className="input-label rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                          suffix={
                            // valueSelected !== "" ? (
                            //   <CloseCircleOutlined
                            //     onClick={() => {
                            //       setValueSelected("");
                            //       setQuery("");
                            //     }}
                            //   />
                            // ) : (
                            //   ""
                            // )
                            <div className="text-[13px] packages-details-main-search-suffix">
                              <h1 className="mt-[-5px]">GO</h1>
                            </div>
                          }
                          name="query"
                          value={query}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </Row>
                  </Col>
                </div>
              </div>
            ))}
          </Slider>
          <div className="w-[100%] relative" ref={destinationSearchRef}>
            {searchDestinationSelected === false ? (
              ""
            ) : (
              <div
                style={{
                  zIndex: 1000,
                  position: "absolute",
                  top:
                    // media == "xl" || media == "lg" || media == "xxl"
                    //   ? "-198px"
                    //   :
                    "-103px",
                  left:
                    media == "xl" || media == "lg" || media == "xxl"
                      ? "28.1%"
                      : media == "md"
                      ? "32.5%"
                      : "26.5%",
                  width:
                    media == "xl" || media == "lg" || media == "xxl"
                      ? "45.1%"
                      : media == "md"
                      ? "37%"
                      : "50%",
                }}
                className={
                  query !== "" && searchArrays.length > 0 && destinationSelected
                    ? ""
                    : query !== "" && searchArrays.length > 0
                    ? "destination-modal-layout absolute bg-white rounded-xl shadow-lg z-10"
                    : query !== "" && searchArrays.length == 0
                    ? "packages-empty-modal-layout absolute bg-white rounded-xl shadow-lg z-10"
                    : query !== ""
                    ? "destination-modal-layout absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"
                    : ""
                }
              >
                {/* {query !== "" ? (
                <div className="border border-b-1 pb-2 border-x-0 border-t-0 flex flex-row pl-6 text-start">
                  <h1
                    style={{
                      marginTop: "19px",
                      marginRight: "25px",
                      color: "black",
                    }}
                  >
                    <FaLocationDot className="text-[20px]" />
                  </h1>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[black] text-[16px] mt-[14px] font-normal"
                  >
                    Top Trending Destinations
                  </h1>
                </div>
              ) : (
                ""
              )} */}
                {searchArrays !== undefined && searchArrays.length > 0 ? (
                  searchArrays.map((suggestion, index) => {
                    const imageUrl =
                      suggestion && suggestion.imageUrl !== undefined
                        ? suggestion.imageUrl
                        : "";
                    const destinationCountry = {
                      destinationId: suggestion._id,
                      lowestPrice: "",
                      activities: suggestion.noOfActivities,
                      packageName: suggestion.destinationName,
                      imageUrl: suggestion.imageUrl ? suggestion.imageUrl : "",
                    };
                    const stateActivitiesData = {
                      destinationId:
                        suggestion && suggestion.countryData !== undefined
                          ? suggestion.countryData._id
                          : "",
                      lowestPrice: "",
                      activities:
                        suggestion && suggestion.stateData !== undefined
                          ? suggestion.stateData.noOfActivities
                          : "",
                      packageName:
                        suggestion && suggestion.stateData !== undefined
                          ? suggestion.stateData.destinationName
                          : "",
                      imageUrl:
                        suggestion &&
                        suggestion.stateData !== undefined &&
                        suggestion.stateData.images &&
                        suggestion.stateData.images.length > 0
                          ? suggestion.stateData.images[0].imageUrl
                          : "",
                    };

                    const destinationCity = {
                      destinationId:
                        suggestion && suggestion.stateData !== undefined
                          ? suggestion.stateData._id
                          : "",
                      cityId: suggestion._id,
                      lowestPrice: "",
                      activityName: suggestion.destinationName,
                      noOfActivities: suggestion.noOfActivities,
                      activityState:
                        suggestion && suggestion.stateData !== undefined
                          ? suggestion.stateData.destinationName
                          : "",
                      imageUrl:
                        suggestion.imageUrl !== undefined
                          ? suggestion.imageUrl
                          : "",
                    };
                    const destinationArea = {
                      activityName: suggestion.destinationName,
                      imageUrl: suggestion.imageUrl ? suggestion.imageUrl : "",
                      // activityCity: "Kochi",
                      // activityState: "Kerala",
                      destinationId: suggestion._id,
                      cityId: suggestion.cityData
                        ? suggestion.cityData._id
                        : "",
                      areaId: suggestion._id,
                      lowestPrice: "",
                      // activityName: suggestion.cityName,
                      noOfActivities: suggestion.noOfActivities,
                      activityCity:
                        suggestion && suggestion.cityData
                          ? suggestion.cityData.destinationName
                          : "",
                      activityState:
                        stateActivitiesData && stateActivitiesData
                          ? stateActivitiesData.packageName
                          : "",
                    };

                    return (
                      <div
                        style={{
                          fontFamily: "Poppins",
                          height:
                            suggestion &&
                            (suggestion.categoryName !== undefined ||
                              suggestion.packageCategoryName !== undefined)
                              ? "55px"
                              : "",
                        }}
                        key={index}
                        onClick={() => {
                          // handleClick(suggestion);
                          setSearchDestinationSelected(false);
                          setDestinationSelected(true);
                          setTimeout(() => {
                            setDestinationSelected(false);
                          }, 1500);

                          if (
                            suggestion &&
                            suggestion.destinationName !== undefined &&
                            suggestion.type !== undefined &&
                            suggestion.type === "Country"
                          ) {
                            history.push({
                              pathname: `/destinations`,
                            });
                            setQuery(suggestion.packageCategoryName);
                          }
                          if (
                            suggestion &&
                            suggestion.destinationName !== undefined &&
                            suggestion.type !== undefined &&
                            suggestion.type === "State"
                          ) {
                            history.push({
                              pathname: `/destinations/destination-in-${destinationCountry.packageName}`,
                              state: destinationCountry,
                            });
                            setQuery(suggestion.destinationName);
                          }
                          if (
                            suggestion &&
                            suggestion.destinationName !== undefined &&
                            suggestion.type !== undefined &&
                            suggestion.type === "City"
                          ) {
                            window.open(
                              `/destinations/destination-in-${
                                stateActivitiesData.packageName
                              }/${
                                destinationCity.activityName
                              }?activities=${encodeURIComponent(
                                JSON.stringify(stateActivitiesData)
                              )}&cityData=${encodeURIComponent(
                                JSON.stringify(destinationCity)
                              )}`,
                              "_blank"
                            );
                            // history.push({
                            //   pathname: `/destinations`,
                            //   // pathname: `/destinations/${suggestion.destinationName}`,
                            //   state: suggestion,
                            // });
                            setQuery(suggestion.destinationName);
                          }
                          if (
                            suggestion &&
                            suggestion.destinationName !== undefined &&
                            suggestion.type !== undefined &&
                            suggestion.type === "Area"
                          ) {
                            window.open(
                              `/destinations/destination-in-${
                                stateActivitiesData.packageName
                              }/${
                                destinationArea.activityCity
                              }/Places to Visit in ${
                                destinationArea.activityCity
                              }/${
                                destinationArea.activityName
                              }?activities=${encodeURIComponent(
                                JSON.stringify(stateActivitiesData)
                              )}&cityList=${encodeURIComponent(
                                JSON.stringify(destinationCity)
                              )}&area=${encodeURIComponent(
                                JSON.stringify(destinationArea)
                              )}`,
                              "_blank"
                            );
                            // history.push({
                            //   pathname: `/destinations`,
                            //   // pathname: `/destinations/${suggestion.destinationName}`,
                            //   state: suggestion,
                            // });
                            setQuery(suggestion.destinationName);
                          }
                          // if (pageRoute == "/packages") {
                          //   dispatch(
                          //     loadPackagesList(
                          //       "?destinationIds=" + suggestion._id
                          //     )
                          //   );
                          // } else {
                          //   history.push({
                          //     pathname: `/packages/${suggestion.destinationName}`,
                          //     state: suggestion,
                          //   });
                          // }
                        }}
                        className={
                          "pl-4 pb-[10px] text-start border border-black-400 border-b-1 border-x-0 hover:bg-[#fff3f3] border-t-0 cursor-pointer"
                        }
                      >
                        <div
                          className={
                            media === "xl"
                              ? "flex"
                              : suggestion &&
                                suggestion.destinationName !== undefined
                              ? "flex justify-between"
                              : "mt-[5px] flex justify-between"
                          }
                        >
                          <div className={"flex mt-[5px] mb-[13px]"}>
                            <Image
                              // loading="lazy"
                              src={imageUrl}
                              preview={false}
                              width={40}
                              height={40}
                              className="border border-lightgray-1 mt-[4px] rounded-md"
                            />

                            <p className="hover:text-[#eb3e43] mt-[15px] text-[14px] font-normal ml-4">
                              {" "}
                              {suggestion &&
                              suggestion.destinationName !== undefined
                                ? suggestion.destinationName
                                : ""}
                            </p>
                          </div>
                        </div>

                        <div className="flex flex-row justify-between mt-[2px] mb-[-5px]">
                          {/* <div className="xl:mt-[-25px] flex flex-row xl:flex-col justify-between mt-[-28px] mb-[-13px]"> */}
                          <h1 className="text-[11.5px] font-semibold text-[#eb3e43]">
                            {suggestion &&
                            suggestion.destinationName !== undefined &&
                            suggestion.type === "State" &&
                            suggestion &&
                            suggestion.countryData !== undefined
                              ? suggestion.countryData.destinationName
                              : suggestion &&
                                suggestion.destinationName !== undefined &&
                                suggestion.type === "City" &&
                                suggestion &&
                                suggestion.stateData !== undefined
                              ? suggestion.stateData.destinationName +
                                " , " +
                                suggestion.countryData.destinationName
                              : suggestion &&
                                suggestion.destinationName !== undefined &&
                                suggestion.type === "Area" &&
                                suggestion &&
                                suggestion.stateData !== undefined
                              ? suggestion.cityData.destinationName +
                                " , " +
                                suggestion.stateData.destinationName +
                                " , " +
                                suggestion.countryData.destinationName
                              : suggestion && suggestion.destinationName
                              ? suggestion.destinationName
                              : ""}
                          </h1>
                          <p className="text-[11.5px] pr-3 font-semibold text-[#eb3e43]">
                            {/* <p className="xl:mt-[-25px] text-[11.5px] pr-3 font-semibold text-[#eb3e43]"> */}
                            {suggestion.type !== undefined
                              ? suggestion.type
                              : ""}
                          </p>
                        </div>
                      </div>
                    );
                  })
                ) : query !== "" && searchArrays.length === 0 ? (
                  <div className="h-[60px] absolute w-[100%] z-100">
                    {/* <div className="h-[70px] absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"> */}
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="w-[100%] flex pl-4 mt-4 text-[14px] justify-center"
                    >
                      {destinationLoading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 40 }} spin />
                          }
                        />
                      ) : (
                        "No data found.."
                      )}
                    </h1>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
        <Row className="mt-2">
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm"
                ? "pr-[6%] pl-[6%]"
                : media == "xs"
                ? "pl-[30px]"
                : media == "md"
                ? "pr-[7%] pl-[7%]"
                : media == "lg"
                ? "pr-[10%] pl-[10%]"
                : media == "xxl"
                ? "pr-[11%] pl-[11%]"
                : "pr-[6.5%] pl-[6.5%]"
            }
          >
            <Breadcrumb
              style={{
                fontFamily: "Poppins",
                color: "blue",
                fontSize: "11px",
              }}
              items={[
                {
                  href: "/",
                  title: "Home",
                  separator: ">",
                },
                {
                  // path: "/user",
                  title: "Destinations",
                },
              ]}
            />
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "pr-[5%] pl-[5%] mt-[10px]"
              : media == "xs"
              ? "pl-[30px] mt-[10px]"
              : media == "md"
              ? "pr-[5%] pl-[5%]"
              : media == "lg"
              ? "pr-[7%] pl-[8%]"
              : media == "xxl"
              ? "pr-[9.5%] pl-[10%]"
              : "pr-[4%] pl-[5%]"
          }
        >
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className="pl-5 pr-5 pt-3 pb-3"
          >
            <div className="w-[100%]">
              <h1
                style={{
                  fontFamily: "Poppins",
                  //   boxShadow: "1px 1px 1px 2px lightgray",
                }}
                className="text-[24px] text-start font-black mb-3"
              >
                Why Book with PlanMiTrip Only?
              </h1>
              <p
                style={{
                  fontFamily: "Poppins",
                  //   boxShadow: "1px 1px 1px 2px lightgray",
                }}
                className="text-[16px]"
              >
                {" "}
                Welcome to PlanMiTrip, your ultimate destination with a vision
                to offer an extraordinary travel experience. Dive into a world
                of possibilities as we provide an extensive array of
                destinations designed to elevate your journey from ordinary to
                unforgettable. So, kickstart your thrilling adventures with
                PlanMiTrip and craft memorable memories.
              </p>
            </div>
          </Col>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className="pl-5 pr-5 pt-3 pb-3"
          >
            <div className="w-[100%]">
              <h1
                style={{
                  fontFamily: "Poppins",
                  //   boxShadow: "1px 1px 1px 2px lightgray",
                }}
                className="text-[16px] text-start mb-3"
              >
                Here are some of the various destinations you can book through
                our website :
              </h1>
              <Row>
                {activitiesList.map((data, index) => {
                  return (
                    <Col
                      md={8}
                      sm={24}
                      lg={8}
                      xl={8}
                      xxl={8}
                      xs={24}
                      key={index}
                      className="pr-3"
                    >
                      <h1
                        style={{
                          fontFamily: "Poppins",
                          //   boxShadow: "1px 1px 1px 2px lightgray",
                        }}
                        className="text-[64px] mt-[-25px] text-[#ffd5d7] text-start"
                      >
                        {data.key}
                      </h1>
                      <div className={"ml-[55px] mt-[-35px]"}>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                            //   boxShadow: "1px 1px 1px 2px lightgray",
                          }}
                          className="text-[16px] font-semibold text-start mb-3"
                        >
                          {data.activityName}
                        </h1>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            //   boxShadow: "1px 1px 1px 2px lightgray",
                          }}
                          className="text-[15px] text-start mb-3"
                        >
                          {data.descriptions}
                        </p>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "pr-[5%] pl-[5%] mt-[10px]"
              : media == "xs"
              ? "pl-[30px] mt-[10px]"
              : media == "md"
              ? "pr-[5%] pl-[5%]"
              : media == "lg"
              ? "pr-[7%] pl-[8%]"
              : media == "xxl"
              ? "pr-[9.5%] pl-[10%]"
              : "pr-[4%] pl-[5%]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <ActivityDetails />
          </Col>
        </Row>

        <Modal
          open={chatModal}
          title=""
          maskClosable={false}
          onClose={() => setChatModal(false)}
          closable
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => setChatModal(false)}
              className="text-[#ffffff]"
            />
          }
          width={600}
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="p-3"
                >
                  <h2 className="text-[#ffffff]">
                    Don't miss out on our exclusive deals & insider only offers!
                  </h2>
                  <div className="text-[#ffffff] mt-2">
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      5 years of Experience in India
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Packages across 50 + Countries
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Best Travel Partner of India
                    </div>
                  </div>
                </Col>
                <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
              </Row>
            </div>
          </Col>
        </Modal>
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Col>
    </React.Fragment>
  );
};

Activities.propTypes = {
  location: PropTypes.any,
};

export default withRouter(Activities);
